import React,{useEffect} from 'react';
import Header from '../../components/Header';
import ChangePasswordMain from './ChangePasswordMain';
import Footer from '../../components/Footer';


const ChangePassword = () => {
        useEffect(() => {
      document.title = "Forgot password | Society of Aquaculture Professionals";
    }, []);
  return (
    <>
      <Header/>

      <ChangePasswordMain />

      <Footer/>
    </>
  );
};

export default ChangePassword;
